// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3mGmg","footer":"ModalFilter_footer__2FBw4"};